const React = require('react');
const ReactView = require('./react_view');
const Coachs = require('../components/CoachsPage').default;

module.exports = ReactView.extend({
  renderComponent() {
    return <Coachs params={this.options.params} />;
  }
});



// WEBPACK FOOTER //
// ./src/views/coaches.js